import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import PHOTO_MEETINGS from '../../api/ressources/SellerApp/photoMeetings';

export const getPhotoMeetings = createAsyncThunk(
  '/getPhotoMeetings',
  async (params) => {
    const response = await PHOTO_MEETINGS.getPhotoMeetings(params)
    return response.data
  }
);

export const getSlots = createAsyncThunk(
  '/getSlots',
  async (saleId) => {
    const response = await PHOTO_MEETINGS.getSlots(saleId)
    return response.data
  }
);

export const getPhotoPacks = createAsyncThunk(
  '/getPhotoPacks',
  async (saleId) => {
    const response = await PHOTO_MEETINGS.getPhotoPacks(saleId)
    return response.data
  }
);

export const updatePhotoPacks = createAsyncThunk(
  '/updatePhotoPacks',
  async ({ saleId, params }) => {
    const response = await PHOTO_MEETINGS.updatePhotoPacks(saleId, params)
    return response.data
  }
);

export const createPhotoMeeting = createAsyncThunk(
  '/createPhotoMeeting',
  async ({ saleId, params }, { rejectWithValue }) => {
    try {
      const response = await PHOTO_MEETINGS.createPhotoMeeting(saleId, params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  photoMeetings: [],
  plannedPhotoMeeting: {},
  newPhotoMeetingModalOpen: false,
  photoPacks: {
    isSubmitting: false
  },
  newPhotoMeetingParams: {
    requestState: '',
    availableSlots: [],
    step: null,
    formValues: {
      contact_name: '',
      last_name: '',
      contact_phone_country_code: '',
      contact_phone_number: '',
      access_details: '',
      start_date: null
    },
    isSubmitting: false,
    errors: {},
    globalError: null
  },
  requestState: '',
};

export const photoMeetingsSlice = createSlice({
  name: 'photoMeetings',
  initialState,
  reducers: {
    resetPhotoMeetings: () => initialState,
    updateNewPhotoMeetingModalOpen: (state, { payload }) => {
      state.newPhotoMeetingModalOpen = payload
    },
    updateStep: (state, { payload }) => {
      state.newPhotoMeetingParams = { ...state.newPhotoMeetingParams, step: payload }
    },
    resetSlots: (state) => {
      state.newPhotoMeetingParams = { ...state.newPhotoMeetingParams, availableSlots: [] }
    },
    updateFormValues: (state, { payload }) => {
      state.newPhotoMeetingParams = { ...state.newPhotoMeetingParams, formValues: payload }
    },
    updateErrors: (state, { payload }) => {
      state.newPhotoMeetingParams = { ...state.newPhotoMeetingParams, errors: payload }
    },
    resetPhotoMeetingSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(getPhotoMeetings.pending, (state) => {
      state.photoMeetings = initialState.photoMeetings;
      state.plannedPhotoMeeting = initialState.plannedPhotoMeeting;
      state.requestState = 'pending'
    })
    builder.addCase(getPhotoMeetings.fulfilled, (state, { payload }) => {
      state.photoMeetings = payload.results;
      state.plannedPhotoMeeting = lastPlannedPhotoMeeting(payload.results);
      state.requestState = 'done'
    })
    builder.addCase(getPhotoPacks.fulfilled, (state, { payload }) => {
      state.photoPacks = payload;
    })
    builder.addCase(updatePhotoPacks.pending, (state) => {
      state.photoPacks = { ...state.photoPacks, isSubmitting: true }
    })
    builder.addCase(updatePhotoPacks.fulfilled, (state, { payload }) => {
      state.photoPacks = { ...payload, isSubmitting: false }
    })
    builder.addCase(getSlots.pending, (state) => {
      state.newPhotoMeetingParams = { ...state.newPhotoMeetingParams, requestState: 'pending' }
    })
    builder.addCase(getSlots.fulfilled, (state, { payload }) => {
      state.newPhotoMeetingParams = { ...state.newPhotoMeetingParams, availableSlots: payload.results, requestState: 'done' }
    })
    builder.addCase(createPhotoMeeting.pending, (state) => {
      state.newPhotoMeetingParams = { ...state.newPhotoMeetingParams, isSubmitting: true, errors: {}, globalError: null }
    })
    builder.addCase(createPhotoMeeting.fulfilled, (state) => {
      state.newPhotoMeetingParams = { ...state.newPhotoMeetingParams, isSubmitting: false, step: 'SuccessAnimation' }
    })
    builder.addCase(createPhotoMeeting.rejected, (state, { payload }) => {
      const message = payload?.error?.message
      const isFieldErrors = message && typeof message === 'object' && !Array.isArray(message)
      state.newPhotoMeetingParams = {
        ...state.newPhotoMeetingParams,
        errors: isFieldErrors ? message : {},
        globalError: isFieldErrors ? null : (typeof message === 'string' ? message : 'Une erreur est survenue'),
        isSubmitting: false
      }
    })
  },
})

const lastPlannedPhotoMeeting = (results) => {
  const planned = results.filter((photoMeeting) => photoMeeting.status === 'planned').pop();

  return planned;
};

export const { resetPhotoMeetings, updateNewPhotoMeetingModalOpen, updateStep, resetSlots, updateFormValues, updateErrors, resetPhotoMeetingSlice } = photoMeetingsSlice.actions;

export default photoMeetingsSlice.reducer;
